<app-ngx-chronology *ngIf="entries.length > 0" [events]="entries" infiniteScroll (scrolled)="onScroll()"
    [infiniteScrollContainer]="selector" [fromRoot]="true" [infiniteScrollDistance]="1" [infiniteScrollThrottle]="250">
</app-ngx-chronology>
<div *ngIf="entries.length === 0" class="row" style="color: rgba(0, 0, 0, 0.25);">
    <div class="col-12">
        <span>{{'NO-HISTORY' | translate}}</span>
    </div>
</div>